import React, { useEffect } from 'react'

const useClickOutside = (ref, callback,) => {

  useEffect(() => {
    // const handleClickOutside = (event) => {
    //   if (ref.current && !ref.current.contains(event.target)) {
    //     callback()
    //   }
    // }

    const handleScroll = () => {
      if (ref.current) {
        ref.current.blur(); // Close the Select dropdown on scroll
      }
    };
  

    // document.addEventListener('click', handleClickOutside);
    document.addEventListener('scroll', handleScroll, true)

    return () => {
      // document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('scroll', handleScroll, true)
    }
  })

  return (
    <div>useClickOutside</div>
  )
}

export default useClickOutside